import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="py-24" data-id="element-148">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-149">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-150">
          <h2 className="text-3xl font-bold tracking-tight text-white md:text-5xl" data-id="element-151">
            El problema real no es el algoritmo
          </h2>
          <p className="mt-6 text-xl text-gray-400" data-id="element-152">
            Es que estás operando{' '}
            <span className="text-white font-semibold" data-id="element-153">sin tablero</span>.
          </p>

          <div className="mt-12 space-y-6 text-left text-lg text-gray-300" data-id="element-154">
            <p data-id="element-155">Cuando no tienes claridad, haces lo que cualquiera haría:</p>
            <ul className="list-disc pl-6 space-y-2 marker:text-red-500" data-id="element-156">
              <li data-id="element-157">Cambias 10 cosas a la vez</li>
              <li data-id="element-158">Borras contenido por impulso</li>
              <li data-id="element-159">Re-subes como loco</li>
              <li data-id="element-160">Spameas acciones intentando “reactivar”…</li>
            </ul>
            <p data-id="element-161">…y sin querer le das más señales de riesgo a la plataforma.</p>
            <div className="mt-8 border-l-4 border-red-500 bg-red-500/5 p-6" data-id="element-162">
              <p className="font-bold text-white" data-id="element-163">
                El resultado: más ansiedad y menos control.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}